module.exports = __webpack_public_path__ + "img/cdz_summary_Image.97a4dedc.png";